var host = window.location.href;
var HOST;

//desenvolvimento jhon
if(host.indexOf("http://localhost:300") > -1)
{
  host = "http://localhost/foco90/v4/Foco90/api/web-services.php";
  HOST = "http://localhost/foco90/sistema/Foco90-api/";
}
//server
else{
  host = "https://api.foco90.com.br/";
  HOST = "https://api.foco90.com.br/";
}

//host = "https://api.foco90.com.br/";
//HOST = "https://api.foco90.com.br/";

const LOGIN = HOST+"usuarios/login/";

/*
  ------------------------------------------
  EXERCICIOS
  ------------------------------------------
*/
const EXERCICIOS = {
  search: HOST+"exercicios/autocomplete/",
  detalhe:HOST+"exercicios/details/",
  remove: HOST+"exercicios/delete/",
  save: HOST+"exercicios/save/",
  lista: HOST+"exercicios/to-list/"
};

/*
  ------------------------------------------
  BLOCOS DE PLANILHA
  ------------------------------------------
*/
const BLOCOS_PLANILHA = {
  search: HOST+"blocos-planilhas/autocomplete/",//host+"?secao=blocos_planilha_search",//
  detalhe: HOST+"blocos-planilhas/details/",
  remove: HOST+"blocos-planilhas/delete/",
  save: HOST+"blocos-planilhas/save/",
  lista: HOST+"blocos-planilhas/to-list/"
};

/*
  ------------------------------------------
  BLOCOS
  ------------------------------------------
*/
const BLOCOS = {
  search: HOST+"blocos/autocomplete/",
  detalhe: HOST+"blocos/details/",
  remove: HOST+"blocos/delete/",
  save: HOST+"blocos/save/",
  lista: HOST+"blocos/to-list/"
};

/*
  ------------------------------------------
  PLANILHAS DE TREINO
  ------------------------------------------
*/
const PLANILHAS_TREINO = {
  search: HOST+"planilhas/autocomplete/",
  detalhe: HOST+"planilhas/details/",
  lista: HOST+"planilhas/to-list/",
  remove: HOST+"planilhas/delete/",
  save: HOST+"planilhas/save/"
};

/*
  ------------------------------------------
  VIDEOS
  ------------------------------------------
*/
const VIDEOS = {
  search: HOST+"videos/autocomplete/",
  detalhe: HOST+"videos/details/",
  lista: HOST+"videos/to-list/",
  remove: HOST+"videos/delete/",
  save: HOST+"videos/save/"
};

/*
  ------------------------------------------
  PLANOS ALIMENTARES
  ------------------------------------------
*/
const PLANOS_ALIMENTARES = {
  detalhe: HOST+"planos-alimentares/details/",
  lista: HOST+"planos-alimentares/to-list/",
  remove: HOST+"planos-alimentares/delete/",
  save: HOST+"planos-alimentares/save/"
};

/*
  ------------------------------------------
  PLANOS
  ------------------------------------------
*/
const PLANOS = {
  detalhe: HOST+"planos/details/",
  lista: HOST+"planos/to-list/",
  remove: HOST+"planos/delete/",
  save: HOST+"planos/save/",
  autocomplete: HOST+"planos/autocomplete/",
};

/*
  ------------------------------------------
  PERGUNTAS
  ------------------------------------------
*/
const PERGUNTAS = {
  detalhe: HOST+"perguntas-frequentes/details/",
  lista: HOST+"perguntas-frequentes/to-list/",
  remove: HOST+"perguntas-frequentes/delete/",
  save: HOST+"perguntas-frequentes/save/"
};

/*
  ------------------------------------------
  DOMICILIAR
  ------------------------------------------
*/
const DOMICILIAR = {
  detalhe: HOST+"treinos-domiciliares/details/",
  lista: HOST+"treinos-domiciliares/to-list/",
  remove: HOST+"treinos-domiciliares/delete/",
  save: HOST+"treinos-domiciliares/save/"
};

/*
  ------------------------------------------
  USUARIOS
  ------------------------------------------
*/
const USUARIOS = {
  detalhe: HOST+"usuarios/details/",
  lista: HOST+"usuarios/to-list/",
  remove: HOST+"usuarios/delete/",
  save: HOST+"usuarios/save/"
};

/*
  ------------------------------------------
  CLIENTES
  ------------------------------------------
*/
const CLIENTES = {
  detalhe: HOST+"clientes/details/",
  lista: HOST+"clientes/to-list/",
  search: HOST+"clientes/autocomplete/",
  cancelar: HOST+"clientes/cancel/",

  clienteDados: HOST+"dados-cliente/dados/load/",
  clienteDadosAtualizar: HOST+"dados-cliente/dados/update/",

  clienteSenhaLoad: HOST+"dados-cliente/alterar-senha/load/",
  clienteSenhaAtualizar: HOST+"dados-cliente/alterar-senha/update/",

  clienteTreinoLoad: HOST+"dados-cliente/tipo-treino/load/",
  clienteTreinoAtualizar: HOST+"dados-cliente/tipo-treino/update/",

  clienteEnderecoLoad: HOST+"dados-cliente/endereco/load/",
  clienteEnderecoAtualizar: HOST+"dados-cliente/endereco/update/",

  gerarBoleto: HOST+'clientes/gerar-boleto/'
};

/*
  ------------------------------------------
  PERFIL
  ------------------------------------------
*/
const PERFIL = {
  load: `${HOST}ws-app/meus-dados/load/`,
  update: `${HOST}ws-app/meus-dados/update/`
};

/*
  ------------------------------------------
  TREINO
  ------------------------------------------
*/
const TREINO = {
  load: `${HOST}ws-app/tipo-treino/load/`,
  update: `${HOST}ws-app/tipo-treino/update/`
};

/*
  ------------------------------------------
  MEU_TREINO
  ------------------------------------------
*/
const MEU_TREINO = {
  load: `${HOST}ws-app/treinos/load/`,
  detalhe: `${HOST}ws-app/treinos/details/`
};

/*
  ------------------------------------------
  ENDERECO
  ------------------------------------------
*/
const ENDERECO = {
  load: `${HOST}ws-app/endereco/load/`,
  update: `${HOST}ws-app/endereco/update/`
};

/*
  ------------------------------------------
  PERFIL
  ------------------------------------------
*/
const ALTERAR_SENHA = {
  update: `${HOST}ws-app/alterar-senha/update/`
};


/*
  ------------------------------------------
  TERMOS
  ------------------------------------------
*/
const PAGINAS = {
  save: HOST+"paginas/save/",
  detalhe: HOST+"paginas/details/"
};

/*
  ------------------------------------------
  MENSAGENS
  ------------------------------------------
*/
const MENSAGENS = {
  lista: HOST+"mensagens/to-list/",
  detalhe: HOST+"mensagens/details/",
  save: HOST+"mensagens/save/"
};


/*
  ------------------------------------------
  UPLOADER
  ------------------------------------------
*/
const UPLOADER = HOST+"uploads/make/";

/*
  ------------------------------------------
  RELATORIOS
  ------------------------------------------
*/
const RELATORIOS = {
  clientesAtivos: HOST+"reports/clientes/ativos/",
  clientesInativos: HOST+"reports/clientes/inativos/",
  clientesTeste: HOST+"reports/clientes/teste/",
  clientesNaoPagantes: HOST+"reports/clientes/teste-expirado/",
  pagamentos: HOST+"reports/pagamentos/geral/",

  adesoesPorData:HOST+"reports/adesoes/por-data/",
  adesoesMesAtual:HOST+"reports/adesoes/mes-atual/",
  adesoesMesAnterior:HOST+"reports/adesoes/mes-anterior/",
  adesoesBoleto:HOST+"reports/adesoes/boleto/",
  adesoesCartao:HOST+"reports/adesoes/cartao/",
  geral:HOST+"reports/clientes/geral/",

};

/*
  ------------------------------------------
  DASHBOARD
  ------------------------------------------
*/
const DASHBOARD = {
  load: HOST+"dashboard/",
};


/*
  ------------------------------------------
  WS
  ------------------------------------------
*/
const WS = {
  perguntas: PERGUNTAS,
  uploader: UPLOADER,
  exercicios : EXERCICIOS,
  blocos_planilha : BLOCOS_PLANILHA,
  blocos: BLOCOS,
  planilhas_treino: PLANILHAS_TREINO,
  videos: VIDEOS,
  planos_alimentares: PLANOS_ALIMENTARES,
  login: LOGIN,
  termos: PAGINAS,
  sobre: PAGINAS,
  politica: PAGINAS,
  ebook: PAGINAS,
  planos: PLANOS,
  domiciliar: DOMICILIAR,
  usuarios: USUARIOS,
  clientes: CLIENTES,
  mensagens: MENSAGENS,
  perfil: PERFIL,
  alterar_senha: ALTERAR_SENHA,
  treino: TREINO,
  endereco: ENDERECO,
  meuTreino: MEU_TREINO,
  relatorios: RELATORIOS,
  dashboard: DASHBOARD
};

export default WS;



// WEBPACK FOOTER //
// ./src/config/Ws.js